"use client";

import { Employer, GovernmentEmployerPicRegistrationDto } from "@entities/employer";
import { GovernmentEmployerPicDetails, GovernmentEmployerPicRegistrationForm } from "@features/registration";
import { Button, Dialog, DialogBody, DialogClose, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@ubud-ui/react-ui-kit";
import { useState } from "react";

function EditDialog({
  payload,
  onSubmit,
}: {
  payload?: GovernmentEmployerPicRegistrationDto | null;
  onSubmit?: (payload: GovernmentEmployerPicRegistrationDto) => void;
}) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSubmit = (data: GovernmentEmployerPicRegistrationDto) => {
    if (onSubmit) {
      setIsOpen(false);
      onSubmit(data);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => setIsOpen(open)}>
      <DialogTrigger asChild>
        <Button className="text-sm font-bold m-0 p-0 w-auto h-auto" variant="link">
          Ubah
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit admin pengelola (PIC)</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <GovernmentEmployerPicRegistrationForm formValue={payload || undefined} onSubmit={handleSubmit}>
            <div className="sticky bottom-0 grid grid-cols-2 gap-3 bg-white py-6 mt-1">
              <DialogClose asChild>
                <Button className="text-sm font-bold" variant="outline">
                  Batal
                </Button>
              </DialogClose>
              <Button className="text-sm font-bold" variant="default">
                Simpan
              </Button>
            </div>
          </GovernmentEmployerPicRegistrationForm>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}

export function GovernmentEmployerPicRegistrationPreview({
  pic,
  onSubmit,
}: {
  pic?: GovernmentEmployerPicRegistrationDto | null;
  onSubmit?: (payload: GovernmentEmployerPicRegistrationDto) => void;
}) {
  return (
    <div>
      <div className="mb-4 flex items-center gap-4">
        <h4 className="flex-1 text-base font-bold">Admin pengelola (PIC)</h4>
        <EditDialog payload={pic} onSubmit={onSubmit} />
      </div>
      <GovernmentEmployerPicDetails
        employer={
          {
            employerable: {
              picName: pic?.pic_name,
              picEmail: pic?.pic_email,
              picIdNumber: pic?.pic_id_number,
              picPhone: pic?.pic_phone,
            },
          } as Employer
        }
      />
    </div>
  );
}
